import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/menu/Menu.css';
import { maskStyle } from '../../utils/icons';
import { useLang, LANGUAGES } from '../../i18n';
import { useGeo, CURRENCIES } from '../../geo';

const ICONS = {
  sports:       'M12 3a9 9 0 100 18 9 9 0 000-18zm0 3l3 2.2-1.1 3.4H10.1L9 8.2zM4.2 10.4l2.7.5M19.8 10.4l-2.7.5M7.2 18l1.6-2.9M16.8 18l-1.6-2.9',
  live:         'M12 4a8 8 0 108 8M12 8v4l2.5 1.6M9.5 3h5M12 3v1.8M18 5l1.5-1.5',
  bets:         'M5 4.5h11a1 1 0 011 1V20l-2-1.3L13 20l-2-1.3L9 20l-2-1.3L5 20zM8 8h7M8 11h7M8 14h4',
  transactions: 'M7 7h11l-2.5-2.5M17 17H6l2.5 2.5',
  promotions:   'M4 9h16v3H4zM5 12v8h14v-8M12 9v11M12 9c-2.5 0-4-1-4-2.5S9.5 4 12 9zm0 0c2.5 0 4-1 4-2.5S14.5 4 12 9z',
  favourites:   'M12 3.5l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.6 9.6l5.8-.8z',
  language:     'M12 3a9 9 0 100 18 9 9 0 000-18zM3 12h18M12 3c2.5 2.5 2.5 16 0 18M12 3c-2.5 2.5-2.5 16 0 18',
  currency:     'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  profile:      'M12 3.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM5 20a7 7 0 0114 0',
  history:      'M12 3a9 9 0 109 9M12 3a9 9 0 00-9 9M3 5v3h3M12 7v5l3 2',
  logout:       'M14 4H6a1 1 0 00-1 1v14a1 1 0 001 1h8M14 12H10M14 12l-2.5-2.5M14 12l-2.5 2.5M19 12h-5',
  login:        'M10 4H6a1 1 0 00-1 1v14a1 1 0 001 1h4M14 12H4M14 12l-2.5-2.5M14 12l-2.5 2.5M19 12h-5',
  kyc:          'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  terms:        'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2M9 12h6M9 15h4',
  privacy:      'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
  responsible:  'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
};

const SPORTS = [
  { key: 'football',         img: 'sport-football',          path: '/football' },
  { key: 'basketball',       img: 'sport-basketball',        path: '/basketball' },
  { key: 'tennis',           img: 'sport-tennis',            path: '/tennis' },
  { key: 'iceHockey',        img: null,                      path: '/ice-hockey' },
  { key: 'tableTennis',      img: 'sport-tabletennis',       path: '/table-tennis' },
  { key: 'volleyball',       img: 'sport-volleyball',        path: '/volleyball' },
  { key: 'rugby',            img: 'sport-rugby',             path: '/rugby' },
  { key: 'americanFootball', img: 'sport-american-football', path: '/american-football' },
  { key: 'handball',         img: 'sport-handball',          path: '/handball' },
  { key: 'mma',              img: 'sport-mma',               path: '/mma' },
];

function MIcon({ name }) {
  return (
    <span className="ico">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d={ICONS[name] || ICONS.profile} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
}

function Row({ icon, label, to, value, toggle, logout: isLogout, onClose, onClick }) {
  const [on, setOn] = useState(toggle === 'on');
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) { onClick(); return; }
    if (toggle != null) { setOn(!on); return; }
    if (to && onClose) { onClose(); setTimeout(() => navigate(to), 260); return; }
    if (to) navigate(to);
  };

  return (
    <button className={'menu-row' + (isLogout ? ' menu-logout' : '')} onClick={handleClick}>
      <MIcon name={icon} />
      <span className="lbl">{label}</span>
      <span className="right">
        {value ? <span className="val">{value}</span> : null}
        {toggle != null ? (
          <span className={'menu-switch' + (on ? ' on' : '')} />
        ) : (
          !value && !isLogout ? <span className="chev" style={maskStyle('ic-chevron')} /> : null
        )}
      </span>
    </button>
  );
}

function LangPicker() {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find(l => l.code === lang) || LANGUAGES[0];

  return (
    <div className="lang-picker">
      <button className="menu-row lang-trigger" onClick={() => setOpen(v => !v)}>
        <MIcon name="language" />
        <span className="lbl">{t('menu.language')}</span>
        <span className="right">
          <span className="val lang-current">{current.flag} {current.label}</span>
          <svg
            className={'lang-chevron' + (open ? ' open' : '')}
            width="12" height="12" viewBox="0 0 12 12" fill="none"
          >
            <path d="M2 4l4 4 4-4" stroke="#5a5972" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>

      {open && (
        <div className="lang-grid">
          {LANGUAGES.map(l => (
            <button
              key={l.code}
              className={'lang-item' + (l.code === lang ? ' active' : '')}
              onClick={() => { setLang(l.code); setOpen(false); }}
            >
              <span className="lang-flag">{l.flag}</span>
              <span className="lang-name">{l.label}</span>
              {l.code === lang && (
                <svg className="lang-check" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2.5 7l3 3 6-6" stroke="#76e1ff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function SportsPicker({ onClose }) {
  const { t } = useLang();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const go = (path) => {
    setOpen(false);
    if (onClose) { onClose(); setTimeout(() => navigate(path), 260); }
    else navigate(path);
  };

  return (
    <div className="lang-picker">
      <button className="menu-row lang-trigger" onClick={() => setOpen(v => !v)}>
        <MIcon name="sports" />
        <span className="lbl">{t('menu.sports')}</span>
        <span className="right">
          <svg
            className={'lang-chevron' + (open ? ' open' : '')}
            width="12" height="12" viewBox="0 0 12 12" fill="none"
          >
            <path d="M2 4l4 4 4-4" stroke="#5a5972" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="sports-grid">
          {SPORTS.map(s => (
            <button key={s.key} className="sports-item" onClick={() => go(s.path)}>
              {s.img
                ? <i style={{ display: 'inline-block', flex: 'none', width: 13, height: 13, backgroundColor: 'currentColor', mask: `url('/img/${s.img}.svg') center center / contain no-repeat`, WebkitMask: `url('/img/${s.img}.svg') center center / contain no-repeat` }} />
                : <svg viewBox="0 0 12 8.571" width="15" height="11" fill="currentColor" style={{ flex: 'none' }}><path d="M12 4.286v1.071C12 7.132 9.314 8.571 6 8.571 2.745 8.571.096 7.183.003 5.452L0 5.357V4.286C0 6.061 2.686 7.5 6 7.5c3.314 0 6-1.439 6-2.214zM6 0c3.314 0 6 1.439 6 3.214C12 4.99 9.314 6.429 6 6.429 2.686 6.429 0 4.989 0 3.214 0 1.439 2.686 0 6 0z" /></svg>
              }
              <span>{t(`home.sports.${s.key}`)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

function CurrencyPicker() {
  const { currency, setCurrency, prices } = useGeo();
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <div className="lang-picker">
      <button className="menu-row lang-trigger" onClick={() => setOpen(v => !v)}>
        <MIcon name="currency" />
        <span className="lbl">{t('menu.currency')}</span>
        <span className="right">
          <span className="val lang-current">{prices.symbol} {currency}</span>
          <svg className={'lang-chevron' + (open ? ' open' : '')} width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 4l4 4 4-4" stroke="#5a5972" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="lang-grid">
          {CURRENCIES.map(c => (
            <button
              key={c.code}
              className={'lang-item' + (c.code === currency ? ' active' : '')}
              onClick={() => { setCurrency(c.code); setOpen(false); }}
            >
              <span className="lang-flag">{c.symbol}</span>
              <span className="lang-name">{c.code}</span>
              {c.code === currency && (
                <svg className="lang-check" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2.5 7l3 3 6-6" stroke="#76e1ff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function MenuScreen({ open, onClose }) {
  const navigate = useNavigate();
  const { t } = useLang();
  const geo = useGeo();

  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });

  useEffect(() => {
    const sync = () => {
      try { setUser(JSON.parse(localStorage.getItem('user'))); } catch { setUser(null); }
    };
    window.addEventListener('userUpdated', sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener('userUpdated', sync); window.removeEventListener('storage', sync); };
  }, []);

  const go = (path) => { onClose(); setTimeout(() => navigate(path), 260); };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
    window.dispatchEvent(new Event('userUpdated'));
    onClose();
    navigate('/');
  };

  const { symbol, rate } = geo.prices;
  const balance = ((user?.solde_actuel != null ? parseFloat(user.solde_actuel) : 0) * rate).toFixed(2);
  const displayName = user?.username || user?.prenom || user?.nom || t('menu.defaultUser');

  return (
    <>
      <div className={'menu-backdrop' + (open ? ' is-open' : '')} onClick={onClose} />
      <div className={'menu' + (open ? ' is-open' : '')}>

        <div className="menu-top">
          <div className="menu-topbar">
            <span className="menu-hello">
              {user ? t('menu.hello', { name: displayName }) : t('menu.welcome')}
            </span>
            <button className="menu-close" onClick={onClose} aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14">
                <path d="M2 2l10 10M12 2L2 12" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        </div>

        <div className="menu-scroll">

          {user ? (
            <>
              <button className="menu-profile" onClick={() => go('/profile/edit')}>
                <span className="menu-avatar" />
                <span>
                  <div className="menu-name">{displayName}</div>
                  <div className="menu-balance">{balance} {symbol}</div>
                </span>
                <span style={{ marginLeft: 'auto', width: 6, height: 11, flex: 'none', background: '#5a5972', ...maskStyle('ic-chevron') }} />
              </button>

              <div className="menu-actions">
                <button className="menu-deposit" onClick={() => go('/deposit')}>{t('menu.deposit')}</button>
                <button className="menu-withdraw" onClick={() => go('/withdrawal')}>{t('menu.withdraw')}</button>
              </div>

              <div className="menu-section">
                <div className="menu-section-title">{t('menu.sectionBetting')}</div>
                <SportsPicker onClose={onClose} />
                <Row icon="live"    label={t('menu.liveBetting')} to="/live-betting"  onClose={onClose} />
              </div>

              <div className="menu-section">
                <div className="menu-section-title">{t('menu.sectionAccount')}</div>
                <Row icon="profile"      label={t('menu.myProfile')}    to="/profile/edit"  onClose={onClose} />
                <Row icon="bets"         label={t('menu.myBets')}       to="/mybets"        onClose={onClose} />
                <Row icon="transactions" label={t('menu.transactions')} to="/transactions"  onClose={onClose} />
                <Row icon="favourites"   label={t('menu.favorites')}    to="/favoris"       onClose={onClose} />
              </div>

              <div className="menu-section">
                <div className="menu-section-title">{t('menu.sectionSettings')}</div>
                <LangPicker />
                <CurrencyPicker />
              </div>

              <div className="menu-section">
                <Row icon="logout" label={t('menu.logout')} logout onClick={handleLogout} />
              </div>
            </>
          ) : (
            <>
              <div className="menu-auth-block">
                <p className="menu-auth-text">{t('menu.loginPrompt')}</p>
                <button className="menu-auth-login" onClick={() => go('/auth')}>
                  {t('menu.signIn')}
                </button>
                <button className="menu-auth-register" onClick={() => go('/auth?tab=signup')}>
                  {t('menu.createAccount')}
                </button>
              </div>

              <div className="menu-section">
                <div className="menu-section-title">{t('menu.sectionNavigation')}</div>
                <SportsPicker onClose={onClose} />
                <Row icon="live"       label={t('menu.liveBetting')} to="/live-betting"  onClose={onClose} />
                <Row icon="promotions" label={t('menu.promotions')}  value="3" />
              </div>

              <div className="menu-section">
                <div className="menu-section-title">{t('menu.sectionSettings')}</div>
                <LangPicker />
                <CurrencyPicker />
              </div>
            </>
          )}

        </div>
      </div>
    </>
  );
}
